import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

// One-line bordered notice on the pricing pages, same box as the Top Down
// recap's "You are viewing…" line.
export default function PricingNotice({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
      className={cn('border rounded-lg px-3 py-2.5 text-[13px] text-foreground', className)}
    >
      {children}
    </div>
  )
}
